import React from 'react';
import useTranslation from '../../../hooks/useTranslation';
import { calculateKPIs } from '../../../services/budgetKPIService';
import { formatCurrency } from '../../../utils/formatCurrency';

const STATUS_BADGE_STYLES = {
  submitted: { bg: 'bg-blue-100',  text: 'text-blue-700'  },
  // Extra reprend le vert de l'ancienne tuile « Approuve ».
  extra:     { bg: 'bg-green-100', text: 'text-green-700' },
  // Meme rouge que la cellule d'un credit dans le tableau (ExtrasTable:497).
  credit:    { bg: 'bg-red-100',   text: 'text-red-600'   },
  rejected:  { bg: 'bg-red-100',   text: 'text-red-700'   },
  // Total garde la couleur de l'ancienne tuile « Approuve ».
  total:     { bg: 'bg-green-100', text: 'text-green-700' },
};

const StatusKPICard = ({ status, label, amount, count }) => {
  const style = STATUS_BADGE_STYLES?.[status] || STATUS_BADGE_STYLES?.submitted;

  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm min-w-[120px]">
      <div className="flex items-center justify-between mb-1">
        <p className="text-[10px] font-medium text-gray-500">{label}</p>
        <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-medium ${style?.bg} ${style?.text}`}>
          {count ?? 0}
        </span>
      </div>
      <p className={`text-sm font-semibold ${style?.text}`}>
        {formatCurrency(amount ?? 0)}
      </p>
    </div>
  );
};

const ExtrasKPICards = ({ extras, constructionCosts, generalCosts, adminCosts, extrasCosts }) => {
  const { t } = useTranslation();

  const kpis = calculateKPIs({
    constructionCosts,
    generalCosts,
    adminCosts,
    extras,
    extrasCosts
  });

  const ss = kpis?.statusSummary;

  return (
    <div className="flex-1 flex items-center justify-end gap-2 flex-wrap">
      <StatusKPICard
        status="submitted"
        label={t('extras.kpi.submitted')}
        amount={ss?.submitted?.amount}
        count={ss?.submitted?.count}
      />
      <StatusKPICard
        status="extra"
        label={t('extras.kpi.extra')}
        amount={ss?.extra?.amount}
        count={ss?.extra?.count}
      />
      <StatusKPICard
        status="credit"
        label={t('extras.kpi.credit')}
        amount={ss?.credit?.amount}
        count={ss?.credit?.count}
      />
      <StatusKPICard
        status="rejected"
        label={t('extras.kpi.rejected')}
        amount={ss?.rejected?.amount}
        count={ss?.rejected?.count}
      />
      {/* Total = l'ancienne tuile « Approuve », calcul inchange, seuls le
          libelle et la position bougent. Doit rester egale a la tuile
          « Extra/Credit » de l'Apercu financier. */}
      <StatusKPICard
        status="total"
        label={t('extras.kpi.total')}
        amount={ss?.approved?.amount}
        count={ss?.approved?.count}
      />
    </div>
  );
};

export default ExtrasKPICards;
